import * as types from './types';
import * as qualificationsActions from 'services/api/qualifications';
import { getErrorMessage } from 'utils';
import { uiActions } from 'state/modules/UI';

const fetchQualificationsRequest = (payload) => ({
  type: types.FETCH_QUALIFICATIONS_REQUEST,
  payload,
});

const fetchQualificationsSuccess = (payload) => ({
  type: types.FETCH_QUALIFICATIONS_SUCCESS,
  payload,
});

const fetchQualificationsFailed = (error) => ({
  type: types.FETCH_QUALIFICATIONS_FAILED,
  error,
});

export const fetchQualifications = (type, params = {}) => {
  return async (dispatch) => {
    dispatch(fetchQualificationsRequest(type));

    const response = await qualificationsActions.fetchQualifications(params);

    if (response.ok) {
      return dispatch(
        fetchQualificationsSuccess({
          type,
          data: response.data,
        })
      );
    }

    dispatch(fetchQualificationsFailed());
  };
};

const fetchQualificationByIdRequest = () => ({
  type: types.FETCH_QUALIFICATION_BY_ID_REQUEST,
});

const fetchQualificationByIdSuccess = (payload) => ({
  type: types.FETCH_QUALIFICATION_BY_ID_SUCCESS,
  payload,
});

const fetchQualificationByIdFailed = (error) => ({
  type: types.FETCH_QUALIFICATION_BY_ID_FAILED,
  error,
});

export const fetchQualificationById = (id, type) => {
  return async (dispatch) => {
    dispatch(fetchQualificationByIdRequest());

    const response = await qualificationsActions.fetchQualificationById(id);

    if (response.ok) {
      return dispatch(
        fetchQualificationByIdSuccess({
          id,
          type,
          data: response.data,
        })
      );
    }

    dispatch(fetchQualificationByIdFailed());
  };
};

const fetchUpdateQualificationRequest = () => ({
  type: types.FETCH_UPDATE_QUALIFICATION_REQUEST,
});

const fetchUpdateQualificationSuccess = (payload) => ({
  type: types.FETCH_UPDATE_QUALIFICATION_SUCCESS,
  payload,
});

const fetchUpdateQualificationFailed = (error) => ({
  type: types.FETCH_UPDATE_QUALIFICATION_FAILED,
  error,
});

export const fetchUpdateQualification = (id, type, requeriment_slug, data) => {
  return async (dispatch) => {
    dispatch(fetchUpdateQualificationRequest());

    const response = await qualificationsActions.fetchUpdateQualification(
      id,
      requeriment_slug,
      data
    );

    if (response.ok) {
      return dispatch(
        fetchUpdateQualificationSuccess({
          id,
          type,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response?.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUpdateQualificationFailed());
  };
};
